<!-- 拍机堂型号映射 -->
<template>
    <span style="color: #fff"> 卡顿优化:将型号的搜索放到后端查询,前端查询与客户端机器的性能有关,会造成一定的卡顿 </span>

    <div>
        <h2 style="color: #fff">型号映射</h2>
        <div class="form-group">
            <!-- 筛选菜单栏 -->
            <el-form :inline="true" :model="formData">
                <!-- 平台 -->
                <el-form-item label="">
                    <el-select v-model="formData.sources" clearable placeholder="平台">
                        <el-option v-for="item in platformList" :key="item.id" :label="item.paramValue" :value="item.paramValue" />
                    </el-select>
                </el-form-item>

                <!-- 其他平台型号 -->
                <el-form-item label="">
                    <el-select v-model="formData.otherModelName" clearable filterable remote placeholder="其他平台型号">
                        <el-option v-for="item in otherPlatformModelList" :key="item" :label="item" :value="item" />
                    </el-select>
                </el-form-item>

                <!-- 系统平台品牌 -->
                <el-form-item label="">
                    <el-select v-model="formData.brandId" clearable filterable remote placeholder="系统平台品牌">
                        <el-option v-for="item in sysPlatformBrandList" :key="item.brandId" :label="item.brandName" :value="item.brandId" />
                    </el-select>
                </el-form-item>

                <!-- 拍机堂型号 -->
                <el-form-item label="">
                    <el-select v-model="formData.productModelName" filterable remote clearable placeholder="系统平台型号">
                        <el-option v-for="item in sysPlatformModelList" :key="item.id" :label="item.modelName" :value="item.modelName" />
                    </el-select>
                </el-form-item>

                <!-- 是否映射 -->
                <el-form-item label="">
                    <el-select v-model="formData.status" clearable placeholder="是否映射">
                        <el-option v-for="item in statusList" :key="item.key" :label="item.key" :value="item.value" />
                    </el-select>
                </el-form-item>

                <!-- 查询 -->
                <el-form-item>
                    <el-button type="primary" @click="searchModelManager()">查询</el-button>
                </el-form-item>
            </el-form>
            <!-- 数据展示 -->
            <el-table :data="correspondenceList">
                <!-- 外部平台 -->
                <el-table-column label="平台" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.sources }}
                    </template>
                </el-table-column>
                <!-- 外部型号 -->
                <el-table-column label="其他平台型号" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.otherPlatformName }}
                    </template>
                </el-table-column>
                <!-- 系统型号 -->
                <el-table-column label="系统平台型号" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.productModelName }}
                    </template>
                </el-table-column>
                <!-- 操作列 -->
                <el-table-column label="操作" header-align="center" align="center" min-width="200px">
                    <template v-slot="scope">
                        <el-button type="success" @click="showAddDialog(scope.row)" v-if="!scope.row.productModelName">添加映射</el-button>
                        <el-button type="success" @click="showEditDialog(scope.row)" v-if="scope.row.productModelName"> 编辑</el-button>
                        <el-button type="danger" @click="handleMappingDelete(scope.row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹窗修改 -->
            <el-dialog v-model="isDialogVisible" :title="currentMapping.editId == undefined ? '新增型号映射' : '修改型号映射'">
                <el-form :model="currentMapping" :rules="rules" ref="formRef" label-width="120px">
                    <el-row>
                        <el-col :span="12">
                            <div style="margin: 0 0 10px 20px; color: #333; font-weight: 700">
                                {{ otherPlatformName }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="系统平台品牌" prop="brandId" v-if="!isBrandId">
                                <el-select v-model="currentMapping.brandId" clearable filterable remote placeholder="系统平台品牌" @change="selectBrandChange">
                                    <el-option v-for="item in sysPlatformBrandList" :key="item.brandId" :label="item.brandName" :value="item.brandId" />
                                </el-select>
                            </el-form-item>
                            <div v-else style="margin: 0 0 10px 20px; color: #333; font-weight: 700">系统平台品牌:{{ isBrandName }}</div>
                            <el-form-item label="系统平台型号" prop="productModelId">
                                <el-select v-model="currentMapping.productModelId" clearable filterable remote placeholder="系统平台型号" @change="selectChange">
                                    <el-option v-for="item in sysPlatformModelList" :key="item.id" :label="item.modelName" :value="item.id" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 操作 -->
                <template v-slot:footer>
                    <div class="dialog-footer">
                        <el-button @click="isDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveMapping">保存</el-button>
                    </div>
                </template>
            </el-dialog>
            <!-- 页码栏 -->
            <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="itemsPerModelPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allPagesmodel">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";

    export default {
        name: "brandcheckView",
        components: { FixedButtons },
        data() {
            return {
                props: { multiple: true, label: "paramValue", value: "看后端传来的" },

                //查询各平台
                platformURL: "/api/systemConfig/queryBySystemConfigSearchDTO",

                // 查询各平台的品牌
                platformBrand: "/api/ProductBrandMapping/init",

                // 查询系统品牌
                sysBrand: "/api/ProductBrand/init",

                // 新增时候系统品牌查询
                addSysBrand: "/api/ProductBrand/queryDataByParam",

                // 分页查询其他平台品牌映射到系统品牌数据
                productBrandMapping: "/api/ProductBrandMapping/queryDataByParam",

                // 添加品牌映射关系
                addBrandMapping: "/api/ProductBrandMapping/insertBrandMapping",

                // 编辑品牌映射关系
                editBrandMapping: "/api/ProductBrandMapping/update",

                // 删除品牌映射关系
                deleteBrandMapping: "/api/ProductBrandMapping/deleteBrandMapping",

                //分页查询其他平台机型映射到系统机型数据
                correspondence: "/api/ProductModelMapping/queryModelMappingDataByParam",

                // 添加型号映射关系
                addMapping: "/api/ProductModelMapping/insertModelMapping",

                // 编辑型号映射关系
                editMapping: "/api/ProductModelMapping/update",

                // 删除型号映射关系
                deleteMapping: "/api/ProductModelMapping/deleteModelMapping",

                // 查询平台和机型映射初始化下拉框
                platformModelMapping: "/api/ProductModelMapping/init",

                // 查询系统标准的品牌和机型初始化下拉框
                syspStandardModel: "/api/ProductModel/init",

                // 系统标准型号
                sysModel: "/api/ProductModel/queryDataByParam",

                // 查询瑕疵数据
                flawData: "/api/PlatformDesc/queryDataByParam",

                // 查询瑕疵数据
                flawData: "/api/PlatformDesc/queryDataByParam",

                // 查询下拉框检索数据
                flawSearch: "/api/PlatformDesc/init",

                // 查询下拉框检索数据
                sysStandardFlaw: "/api/PjtDamageStandards/init",

                // 新增瑕疵映射
                addFlawMapping: "/api/PlatformDescReflect/insert",

                // 修改瑕疵映射
                editFlawMapping: "/api/PlatformDescReflect/update",

                // 删除瑕疵映射
                deleteFlawMapping: "/api/PlatformDescReflect/delete",

                // 当前页码
                currentPage: 1,
                // 默认每页显示条目数
                itemsPerPage: 10,
                itemsPerBrandPage: 10,
                itemsPerModelPage: 10,
                itemsPerFlawPage: 10,
                // 总页数
                allPagesBrand: 1,
                allPagesmodel: 1,
                allPagesFlaw: 1,

                BrandReflectShow: true,
                modelReflectShow: false,
                damageReflectShow: false,

                activeName: "first",

                formBrandData: {
                    otherBrandName: "", // 其他平台型号
                    productBrandName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                platformBrandList: [], //平台品牌
                sysBrandList: [], // 系统品牌
                addSysBrandList: [], // 添加时候的系统品牌
                isBrandDialogVisible: false, //新增编辑弹框
                // brandId: '', //新增id
                // productBrandId: '', //新增品牌id
                brandMappingmName: "",
                currentBrandMapping: {
                    editId: undefined,
                    id: "",
                    productBrandId: "",
                    brandName: "",
                },
                BrandMappingList: [], //其他平台映射系统平台列表

                formData: {
                    brandId: "", //系统品牌id
                    otherModelName: "", // 其他平台型号
                    productModelName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                statusList: [
                    { key: "已映射", value: "0" },
                    { key: "未映射", value: "1" },
                ],
                platformList: [], // 平台信息
                correspondenceList: [], // 对应信息
                sysPlatformBrandList: [], //系统平台品牌
                sysPlatformModelList: [], //系统平台型号
                otherPlatformModelList: [], // 其他平台型号
                sources: "", //平台
                brandId: "",
                isBrandId: "", //系统平台品牌是否映射过
                isBrandName: "",
                isDialogVisible: false, //新增编辑弹框
                sysModelList: [], // 系统标准型号列表
                otherPlatformName: "",
                currentMapping: {
                    editId: undefined,
                    id: "",
                    brandId: "",
                    productModelId: "",
                    modelName: "",
                    editProductModelId: "",
                },

                formFlawData: {
                    descLevel1: "", //一级瑕疵
                    descLevel2: "", // 二级瑕疵
                    standardsKeyWord: "", // 系统瑕疵
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                flawDataList: [], // 瑕疵映射列表
                flawOneLevelList: [], //一级瑕疵
                flawTwoLevelList: [], //二级瑕疵
                sysStandardFlawListOne: [], //系统一级瑕疵数据
                sysStandardFlawListTwo: [], //系统二级瑕疵数据
                sysStandardFlawListThree: [], //系统三级瑕疵数据
                isFlawDialogVisible: false, //瑕疵弹框
                currentFlawMapping: {
                    editId: undefined,
                    id: "",
                    sdandardsLevel1: "", //一级名字
                    sdandardsLevel2: "", //二级名字
                    sdandardsLevel3: "", //三级名字
                    otherPlatformDescId: "",
                    pjtDescId: "",
                },
                otherPlatformNameFlaw: "",

                rules: {
                    modelName: [{ required: true, message: "系统标准型号不能为空", trigger: "blur" }],
                },
            };
        },
        created() {
            this.nickName = localStorage.getItem("nickname") || "";
            this.phone = localStorage.getItem("tel") || "";
            // this.getPlatformList();
            // this.getPlatformModelMapping();
            // this.getSyspStandardModel();
            // this.getCorrespondenceList();

            // this.getFlawDataList();
            // this.getFlawSearchList();
        },
        methods: {
            // 初始化页面
            nowtabInit() {
                this.nickName = localStorage.getItem("nickname") || "";
                this.phone = localStorage.getItem("tel") || "";
                this.getPlatformList();
                this.getPlatformModelMapping();
                this.getSyspStandardModel();
                this.getCorrespondenceList();
            },
            // 删除映射型号
            handleMappingDelete(row) {
                try {
                    this.$confirm("确认删除当前映射吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            axios
                                .delete(this.deleteMapping + `?idList=${row.id}`, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.getCorrespondenceList();
                                    } else {
                                        this.$message.error(res.data.data);
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("删除失败", error);
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除",
                            });
                        });
                } catch (error) {
                    console.error("Failed to delete user:", error);
                }
            },

            //改变页数
            handleCurrentChange1(val) {
                this.currentPage = val;
                this.getCorrespondenceList();
            },

            // 改变条数
            handleSizeChange1(val) {
                this.itemsPerModelPage = val;
                this.getCorrespondenceList();
            },

            // 新增保存and编辑保存
            saveMapping() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (this.currentMapping.editId === undefined) {
                            const body = { id: this.currentMapping.id, productModelId: this.currentMapping.productModelId };
                            axios
                                .post(this.addMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isDialogVisible = false;
                                        this.getCorrespondenceList();
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        } else {
                            const body = { id: this.currentMapping.id, productModelId: this.currentMapping.productModelId };
                            axios
                                .put(this.editMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isDialogVisible = false;
                                        this.getCorrespondenceList();
                                        this.currentMapping.productModelId = "";
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        }
                    }
                });
            },

            // 查询
            searchModelManager() {
                this.getCorrespondenceList();
            },
            // 编辑型号映射
            showEditDialog(row) {
                this.isDialogVisible = true;
                this.isBrandId = row.brandId;
                this.isBrandName = row.brandName;
                this.otherPlatformName = row.otherPlatformName;
                this.currentMapping.productModelId = row.productModelName;
                this.currentMapping.editId = row.id;
                this.currentMapping.id = row.id;
                this.currentMapping.editProductModelId = row.id;
                this.currentMapping.modelName = row.modelName;
                this.getSyspStandardModel();
            },

            // 新增型号映射关系
            showAddDialog(row) {
                this.isDialogVisible = true;
                this.isBrandId = row.brandId;
                this.isBrandName = row.brandName;
                this.otherPlatformName = row.otherPlatformName;
                this.currentMapping.id = row.id;
                this.currentMapping.brandId = "";
                this.currentMapping.productModelId = "";
                this.getSyspStandardModel();
            },
            // 查询平台
            getPlatformList() {
                axios
                    .get(this.platformURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                        },
                    })
                    .then((res) => {
                        this.platformList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 型号映射关系列表
            getCorrespondenceList() {
                axios
                    .get(this.correspondence, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            ...this.formData,
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerModelPage,
                        },
                    })
                    .then((res) => {
                        this.allPagesmodel = res.data.data.total;
                        this.correspondenceList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询平台和机型映射初始化下拉框
            getPlatformModelMapping(val) {
                axios
                    .get(this.platformModelMapping, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerModelPage,
                            sources: val,
                        },
                    })
                    .then((res) => {
                        this.otherPlatformModelList = res.data.data.otherPlatformNameList;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询系统标准的品牌和机型初始化下拉框
            getSyspStandardModel(val) {
                axios
                    .get(this.syspStandardModel, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerModelPage,
                            brandId: val ? val : this.isBrandId,
                        },
                    })
                    .then((res) => {
                        if (val) {
                            this.sysPlatformModelList = res.data.data.modelNameList;
                        } else {
                            this.sysPlatformBrandList = res.data.data.brandIdAndNameList;
                            this.sysPlatformModelList = res.data.data.modelNameList;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            selectBrandChange(value) {
                this.currentBrandMapping.productBrandId = value;
            },

            // 新增保存and编辑保存
            saveBrandMapping() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (this.currentBrandMapping.editId === undefined) {
                            const body = {
                                id: this.currentBrandMapping.id,
                                productBrandId: this.currentBrandMapping.productBrandId,
                            };
                            axios
                                .post(this.addBrandMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isBrandDialogVisible = false;
                                        this.getBrandMappingList();
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        } else {
                            const body = {
                                id: this.currentBrandMapping.id,
                                productBrandId: this.currentBrandMapping.productBrandId,
                            };
                            axios
                                .put(this.editBrandMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isBrandDialogVisible = false;
                                        this.getBrandMappingList();
                                        this.currentBrandMapping.productBrandId = "";
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        }
                    }
                });
            },

            // 改变条数
            handleSizeChange(val) {
                this.itemsPerBrandPage = val;
                this.getBrandMappingList();
            },

            //改变页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getBrandMappingList();
            },
        },
        watch: {},
        computed: {},
        mounted() {},
    };
</script>

<style lang="scss" scoped></style>
